var map = {
	"./channel-management/route": [
		23558,
		1625
	],
	"./customer-management/route": [
		79224,
		377
	],
	"./demo/route": [
		25135,
		9246
	],
	"./home/route": [
		54070,
		6926
	],
	"./iam/route": [
		47205,
		6100,
		6158
	],
	"./index-management/route": [
		56808,
		387
	],
	"./qst-management/route": [
		10343,
		8986
	],
	"./system-management/route": [
		1591,
		8730,
		350,
		7086
	],
	"./wx-content-management/route": [
		38310,
		5494
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37674;
module.exports = webpackAsyncContext;